export default class LoginPage {
    constructor() {
        return {
            template: require('../../../../views/login/pages/p-login.html'),
            controller: LoginPageController,
            controllerAs: 'login',
            bindings: {
                isExternal: '<'
            }
        }
    }
}

class LoginPageController {

    constructor($element, $scope) {

        this.formFields = {
            email: null,
            password: null
        };

        $scope.$on('event:auth.loginRequired', () => {
            window.location.href = '/v5/#/auth/login';
        });

        this.$onInit = () => {
            $element.addClass('p-login');
        }
    };
}

